import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyB85e_dhrLunYG6fFci9TaCXeFztYCZYJI",
  authDomain: "react-app-curso-ff0a3.firebaseapp.com",
  projectId: "react-app-curso-ff0a3",
  storageBucket: "react-app-curso-ff0a3.appspot.com",
  messagingSenderId: "12112602834",
  appId: "1:12112602834:web:834193b3f188900c8cef0b"
};

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
export {
  db,
  googleAuthProvider,
  firebase
}